var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"viewport"}),_c('div',{ref:"toolbar"}),_c('div',{ref:"topbutton"}),_c('div',{ref:"player"}),_c('div',{ref:"sidebar"}),_c('div',{ref:"menubar"}),_c('div',{ref:"resizer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }